var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "--bgSolid --withBorder d-flex justify-content-between align-items-center"
    },
    [
      _c("img", {
        staticClass: "img-fluid header__logo",
        attrs: {
          src: "assets/img/adoptuj-kravicku-logo.svg",
          alt: "adoptuj-kravicku-logo"
        }
      }),
      _vm._v(" "),
      _vm.profil.pouzivatel_id
        ? _c("menu-user", { attrs: { profil: _vm.profil } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }